import { translate } from 'lit-translate';
import { ERROR_CODES } from './errors';

export const getErrorMessage = errorCode =>
  ERROR_CODES.includes(errorCode)
    ? translate(`errors.${errorCode}`)
    : translate('errors.unexpected_error');
